const defaultSteps = [
    {
        id: 1,
        name: 'Credenciamento',
        tag: 'credenciamento',
        link: '',
        completed: false,
        seted: true,
        editing: false,
    },
    {
        id: 2,
        name: 'Chamado',
        tag: 'chamado',
        link: '',
        completed: false,
        seted: false,
        editing: false,
    },
    {
        id: 3,
        name: 'Reservar Unidades',
        tag: 'reserva',
        link: '',
        completed: false,
        seted: false,
        editing: false,
    },
    {
        id: 4,
        name: 'Validação de Dados',
        tag: 'validacao',
        link: '',
        completed: false,
        seted: false,
        editing: false,
    },
    {
        id: 5,
        name: 'Realizar pagamento',
        tag: 'pagamento',
        link: '',
        completed: false,
        seted: false,
        editing: false,
    },
]

export { defaultSteps }